export default __webpack_public_path__ + "static/media/image3.03a60f30.png";